export const tourData = [
  {
    id: 1,
    city: "New York",
    img: "./img/newyork.jpeg",
    name: "Brooklyn Bridge Tour",
    info:
      "Combine an introduction to Manhattan with a walk across the Brooklyn Bridge in just a few hours, saving time with a guide who knows the best ways around the city to see more in less time. Walk from Manhattan to the trendy Dumbo neighborhood of Brooklyn, and cross the Brooklyn Bridge. Your guide tells you NYC history and fun city facts as you stroll.",
  },
  {
    id: 2,
    city: "Paris",
    img: "./img/paris.jpeg",
    name: "Louvre Museum Tour",
    info:
      "Primarily associated with the steady gaze of Leonardo Da Vinci's famous Mona Lisa, Paris' Louvre museum is home to a 35,000-strong collection of paintings and sculptures considered one of the greatest in the world. The contemporary glass Louvre Pyramid heralds the museum's entrance, which millions of tourists flock to every year to feast their eyes on masterpieces that span from antiquity to the 20th century.",
  },
  {
    id: 3,
    city: "London",
    img: "./img/london.jpeg",
    name: "London Royal Palace Tours",
    info:
      "Historic Royal Palaces was originally set up in 1989 as an executive agency of the Department of the Environment. In 1998 it became an independent charity, which is contracted by the Secretary of State for Culture, Media and Sport to manage the palaces on behalf of the Queen. It receives no funding from the Government or the Crown, depending on the support of visitors, members, donors, volunteers and sponsors. 4.25 million people visited the palaces in the 2014–15 financial year.",
  },
  {
    id: 4,
    city: "Tokyo",
    img: "./img/tokyo.jpeg",
    name: "Tokyo City Tour",
    info:
      "Tokyo City (東京市, Tōkyō-shi) was a municipality in Japan and part of Tokyo-fu which existed from 1 May 1889 until its merger with its prefecture on 1 July 1943. The historical boundaries of Tokyo City are now occupied by the 23 Special Wards of Tokyo. The new merged government became what is now Tokyo, also known as the Tokyo Metropolis, or, ambiguously, Tokyo Prefecture.",
  },
];
